module.exports = __webpack_public_path__ + "static/media/Purchase-logs.efffd22a.png";